// extracted by extract-css-chunks-webpack-plugin
module.exports = {"side-scroller":"side-scroller___yjzAL","scroller":"scroller___1Fk7S","container":"container___3IZhW","previous":"previous___2f_1X","next":"next___iHpDL"};